import React from 'react'
import type { AvailabilityStatus } from '../types'

interface AvailabilityBadgeProps {
  status: AvailabilityStatus | null | undefined
  reason?: string | null
  compact?: boolean
}

const STATUS_CONFIG: Record<string, { label: string; className: string; title: string }> = {
  injured: {
    label: 'INJ',
    className: 'availability-badge availability-injured',
    title: 'Injured - Out',
  },
  doubtful: {
    label: 'DTF',
    className: 'availability-badge availability-doubtful',
    title: 'Doubtful',
  },
  suspended: {
    label: 'SUS',
    className: 'availability-badge availability-suspended',
    title: 'Suspended',
  },
  confirmed_out: {
    label: 'OUT',
    className: 'availability-badge availability-out',
    title: 'Not in confirmed squad',
  },
  confirmed_in: {
    label: 'IN',
    className: 'availability-badge availability-in',
    title: 'In confirmed squad',
  },
  available: {
    label: '',
    className: '',
    title: 'Available',
  },
}

export function AvailabilityBadge({ status, reason, compact }: AvailabilityBadgeProps) {
  if (!status || status === 'available') return null

  const config = STATUS_CONFIG[status]
  if (!config || !config.label) return null

  const title = reason ? `${config.title}: ${reason}` : config.title

  return (
    <span
      className={`${config.className}${compact ? ' availability-badge-compact' : ''}`}
      title={title}
    >
      {config.label}
    </span>
  )
}
